// # WARNING
// NEVER REQUIRE './device.js' HERE OR SONETHING - TOTALLY REDUNDANT
// IF `navigator` HAS `msSaveBlob`, IT *IS* THE INTERNET EXPLORER

// # COMMON TODOs
// TODO: should we really do concern about existence of navigator?
// TODO: msSaveBlob? msSaveOrOpenBlob?

/**
 * check if given URL is blob:// or not.
 * @todo CORS check? (<a download> will only work in same origin)
 * @param {URL} url
 * @param {Array?} excepts array of allowed schemas
 */
const checkURL = (url, excepting = ['http:', 'https:', 'blob:', 'data:']) => {
  return excepting.includes(url.protocol);
};

/**
 * saves content of URL using <a download> with no check.
 * @function
 * @name saveURL
 * @param {String|URL} url
 * @param {String?} filename
 */
const saveURL = (url, filename) => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = url.toString();
  link.click();
};

/**
 * saves blob.
 * @function @async
 * @name saveMsBlob
 * @param {Blob} blob
 * @param {String?} filename
 */
const saveBlob = (blob, filename) =>
  new Promise((resolve, reject) => {
    if (navigator?.msSaveBlob) {
      navigator.msSaveBlob(blob, filename) ? resolve() : reject();
    } else {
      // pass to saveURL() using object URI of given Blob.
      const reader = new FileReader();
      // TODO: this never throws? this never emits onerror?
      // TODO: is this always safe incl. for large files?
      reader.onload = (event) => resolve(saveURL(event.target.result, filename));
      reader.readAsDataURL(blob);
    }
  });

/**
 * turns URL into Blob object.
 * Fetch API handles (almost) all incl. blob: and data: schema.
 * @function @async
 * @name fetchBlob
 * @param {String|URL} url
 */
const toBlob = (url) =>
  fetch(url.toString()).then((response) => {
    if (!response.ok) {
      throw new Error(`fetchBlob() request failed with HTTP Error ${response.status} (${response.statusText})`);
    }
    return response.blob();
  });

/**
 * make User-Agent downloads file to local filesystem.
 * if UA don't support <a download>, this will fallback to (XHR+)msSaveBlob().
 * @function @async
 * @name saveFile
 * @param {String|URL|Blob} target @todo ArrayBuffer???
 * @param {String?} filename
 * @param {Object?} options
 * @todo document it
 */
/**
 * overloading JSDoc definition; does it work?
 * @todo if no filename given (either <a download=> or msSaveBlob), will browser name it automatically for me?
 * @function @async
 * @name saveFile
 * @param {String|URL|Blob} target
 * @param {Object} options
 */
export const saveFile = async (target, filename, options) => {
  if (target == null) {
    throw new TypeError('saveFile() called without target file');
  }

  if (options == null && filename instanceof Object) {
    [filename, options] = [undefined, filename]; // FIXME
  }

  const {
    forceBlob = false,
    // TODO: 'strategy' option -> link, link-blank, file-api, ...
  } = options ?? {};

  // check about conditionals

  const shouldBlob = forceBlob || navigator?.msSaveBlob;
  const isBlob = target instanceof Blob; // FYI: File() instanceof Blob === true
  const isURL = typeof target === 'string' || target instanceof URL;

  if (isURL) {
    // FIXME: relative URL can't be used
    target = new URL(target);
    if (!checkURL(target)) {
      throw new TypeError('saveFile() called with insufficant schema');
    }
  } else if (!isBlob) {
    throw new TypeError(`String, Blob, or URL excepted but ${target.__proto__.constrcutor.name} given`);
  }

  if (shouldBlob || isBlob) {
    // it's blob, sure would not, but it should be Blob anyway.
    const blob = isBlob ? target : await toBlob(target);
    return saveBlob(blob, filename);
  } else if (isURL) {
    // it's just an URL.
    return saveURL(target, filename);
  }
};
